import { environment } from "environments/environment";

export const config = {

    serverUrl: environment.serverUrl,
    serverStorageUrl: environment.serverStorageUrl,
    soketHost: environment.soketHost,

    availableLanguages: ['en', 'ru'],
    defaultLocale: 'en',
    langField: 'usrLang',
    tokenField: 'usrToken',
    socketTokenField: 'socketToken',
    userField: 'usrData',
    permissionsField: 'AclService',
    companiesField: 'companies',
    gmtListField: 'gmtList',
    fieldList: 'fieldList',
    fieldListLegal: 'fieldListLegal',
    perPageField: 'perPage',
    perPageDefault: 15,
    filterUrl: 'filteredUrl',
    layoutConfig: 'layoutConfig',


    /* main config */

    layout          : {
        navigation      : 'left', // 'right', 'left', 'top', 'none'
        navigationFolded: false, // true, false
        toolbar         : 'below', // 'above', 'below', 'none'
        footer          : 'below', // 'above', 'below', 'none'
        mode            : 'fullwidth', // 'boxed', 'fullwidth'
        layoutOptions   : true,
    },
    colorClasses    : {
        toolbar: 'mat-white-500-bg',
        navbar : 'mat-fuse-dark-700-bg',
        footer : 'mat-fuse-dark-900-bg'
    },
    customScrollbars: true,
    routerAnimation : 'fadeIn', // fadeIn, slideUp, slideDown, slideRight, slideLeft, none
};



// WEBPACK FOOTER //
// ./src/app/config.ts